import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { PaginationBase } from "@faire/web--source/slate/Pagination/PaginationBase";
import * as React from "react";
export var Pagination = function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ _jsx(PaginationBase, _object_spread({}, props));
};
